<template>
  <a
    class="govuk-back-link"
    role="button"
    aria-label="go back to the previous screen"
  >
    <strong>Back</strong>
  </a>
</template>

<script>
export default {
  name: "backButton",
  // props: {
  //   goBack: { type: Function },
  // },
};
</script>
